import {fromJS} from 'immutable'

import {
  SET_TOP_EXPERTS
} from '../action_types'

const getTopExperts = (experts, count) => {
  return fromJS(experts)
    .toList()
    .sortBy((expert) => -1 * expert.get('rating'))
    .take(count)
}

export default (state, action) => {
  switch (action.type) {
    case SET_TOP_EXPERTS:
      return getTopExperts(action.experts, action.count)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/top_experts.js
 **/